import React from 'react';
import { Mail, Phone, Clock, MapPin } from 'lucide-react';
import { MagneticButton } from '../components/animated/MagneticButton';
export function ContactPage() {
  const handleCalendlyClick = () => {
    window.open('https://calendly.com/precious-ajoonu', '_blank');
  };
  return <div className="flex flex-col min-h-screen bg-white" data-id="element-775">
      <main className="flex-grow pt-32" data-id="element-776">
        {/* Hero Section */}
        <section className="bg-gradient-to-br from-blue-50 to-white py-16" data-id="element-777">
          <div className="container mx-auto px-4 md:px-6 lg:px-8" data-id="element-778">
            <div className="max-w-4xl mx-auto text-center" data-id="element-779">
              <h1 className="text-4xl md:text-5xl font-bold tracking-tight text-gray-900 mb-6" data-id="element-780">
                We'd Love to Hear From You
              </h1>
              <p className="text-xl text-gray-600 mb-8" data-id="element-781">
                Whether you have questions about our consulting services, need
                help upskilling your team, or just want to learn more about
                SkillzHQ, our team is here to assist you.
              </p>
              <MagneticButton variant="primary" size="lg" onClick={handleCalendlyClick} data-id="element-782">
                Book a Discovery Call
              </MagneticButton>
            </div>
          </div>
        </section>

        {/* Contact Information */}
        <section className="py-16 bg-white" data-id="element-783">
          <div className="container mx-auto px-4 md:px-6 lg:px-8" data-id="element-784">
            <div className="max-w-4xl mx-auto" data-id="element-785">
              <h2 className="text-3xl font-bold text-gray-900 mb-12 text-center" data-id="element-786">
                Get in Touch
              </h2>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12" data-id="element-787">
                <div className="bg-blue-50 p-8 rounded-lg" data-id="element-788">
                  <div className="flex items-center mb-4" data-id="element-789">
                    <Mail className="h-6 w-6 text-blue-600 mr-3" data-id="element-790" />
                    <h3 className="text-xl font-bold text-gray-900" data-id="element-791">Email</h3>
                  </div>
                  <a href="mailto:support@myskillzhq.com" className="text-blue-600 hover:text-blue-700" data-id="element-792">
                    support@myskillzhq.com
                  </a>
                </div>

                <div className="bg-blue-50 p-8 rounded-lg" data-id="element-793">
                  <div className="flex items-center mb-4" data-id="element-794">
                    <Phone className="h-6 w-6 text-blue-600 mr-3" data-id="element-795" />
                    <h3 className="text-xl font-bold text-gray-900" data-id="element-796">Phone</h3>
                  </div>
                  <a href="tel:+2348106836707" className="text-blue-600 hover:text-blue-700" data-id="element-797">
                    0810 683 6707
                  </a>
                </div>

                <div className="bg-blue-50 p-8 rounded-lg" data-id="element-798">
                  <div className="flex items-center mb-4" data-id="element-799">
                    <Clock className="h-6 w-6 text-blue-600 mr-3" data-id="element-800" />
                    <h3 className="text-xl font-bold text-gray-900" data-id="element-801">
                      Office Hours
                    </h3>
                  </div>
                  <p className="text-gray-700" data-id="element-802">
                    Monday - Friday
                    <br data-id="element-803" />
                    8:00 AM - 5:00 PM
                  </p>
                </div>

                <div className="bg-blue-50 p-8 rounded-lg" data-id="element-804">
                  <div className="flex items-center mb-4" data-id="element-805">
                    <MapPin className="h-6 w-6 text-blue-600 mr-3" data-id="element-806" />
                    <h3 className="text-xl font-bold text-gray-900" data-id="element-807">Address</h3>
                  </div>
                  <p className="text-gray-700" data-id="element-808">
                    SkillzHQ Headquarters
                    <br data-id="element-809" />
                    Jeydens Court, Agungi, Lagos
                  </p>
                </div>
              </div>

              {/* CTA Section */}
              <div className="bg-gradient-to-br from-blue-600 to-green-600 p-8 rounded-2xl text-center" data-id="element-810">
                <h3 className="text-2xl font-bold text-white mb-4" data-id="element-811">
                  Ready to Transform Your Organization?
                </h3>
                <p className="text-blue-100 mb-6" data-id="element-812">
                  Schedule a 30-minute discovery call with our team to discuss
                  your needs and explore how we can help.
                </p>
                <MagneticButton variant="secondary" size="lg" onClick={handleCalendlyClick} data-id="element-813">
                  Book a Discovery Call
                </MagneticButton>
              </div>
            </div>
          </div>
        </section>
      </main>
    </div>;
}